import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "v1-reference",
  "data-testid": "v1-reference"
}
const _hoisted_2 = {
  key: 0,
  class: "v1-reference__instructions",
  "data-testid": "v1-reference-instructions"
}
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = {
  key: 1,
  class: "v1-reference__map",
  "data-testid": "v1-reference-map"
}
const _hoisted_5 = { class: "v1-reference__map-frame" }
const _hoisted_6 = {
  class: "v1-reference__map-pill",
  "data-testid": "v1-reference-map-pill"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "v1-reference__cta" }
const _hoisted_9 = { "data-testid": "v1-reference-unsupported" }
const _hoisted_10 = { class: "v1-reference__cta" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_V1ReferenceCodeCard = _resolveComponent("V1ReferenceCodeCard")!
  const _component_AlertBanner = _resolveComponent("AlertBanner")!
  const _component_Notice = _resolveComponent("Notice")!
  const _component_DetailList = _resolveComponent("DetailList")!
  const _component_NoPayments = _resolveComponent("NoPayments")!

  return (_ctx.loading)
    ? (_openBlock(), _createBlock(_component_Loading, {
        key: 0,
        title: _ctx.t('loading'),
        fullscreen: ""
      }, null, 8, ["title"]))
    : (_ctx.error)
      ? (_openBlock(), _createBlock(_component_ErrorMessage, {
          key: 1,
          "error-title": _ctx.errorInfo?.title,
          "error-description": _ctx.errorInfo?.description
        }, null, 8, ["error-title", "error-description"]))
      : (_ctx.reference)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_ctx.isCodeType)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.codes, (code, index) => {
                    return (_openBlock(), _createBlock(_component_V1ReferenceCodeCard, {
                      key: index,
                      code: code,
                      "data-testid": `v1-reference-code-${index}`
                    }, null, 8, ["code", "data-testid"]))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notes, (note, noteIndex) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: noteIndex }, [
                      (note.level === 'warn')
                        ? (_openBlock(), _createBlock(_component_AlertBanner, {
                            key: 0,
                            content: note.body,
                            "icon-alt": "Warning"
                          }, null, 8, ["content"]))
                        : (_openBlock(), _createBlock(_component_Notice, {
                            key: 1,
                            title: note.title ?? undefined,
                            body: note.body
                          }, null, 8, ["title", "body"]))
                    ], 64))
                  }), 128)),
                  _createVNode(_component_DetailList, {
                    variant: "rows",
                    items: _ctx.detailItems,
                    "data-testid": "v1-reference-details"
                  }, null, 8, ["items"]),
                  (_ctx.steps.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode(_component_DetailList, {
                          variant: "numbered",
                          title: _ctx.t('instructions'),
                          items: _ctx.stepItems,
                          "data-testid": "v1-reference-steps"
                        }, null, 8, ["title", "items"]),
                        (_ctx.instructionsImage)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: _ctx.instructionsImage,
                              class: "v1-reference__instructions-image",
                              alt: _ctx.reference.provider.displayName
                            }, null, 8, _hoisted_3))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.mapUrl)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("span", _hoisted_6, [
                            _cache[2] || (_cache[2] = _createElementVNode("svg", {
                              viewBox: "0 0 24 24",
                              width: "16",
                              height: "16",
                              "aria-hidden": "true"
                            }, [
                              _createElementVNode("path", {
                                fill: "currentColor",
                                d: "M12 2a7 7 0 0 0-7 7c0 5 7 13 7 13s7-8 7-13a7 7 0 0 0-7-7Zm0 9.5A2.5 2.5 0 1 1 12 6.5a2.5 2.5 0 0 1 0 5Z"
                              })
                            ], -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.t("nearby-stores")), 1)
                          ]),
                          _createElementVNode("iframe", {
                            allow: "geolocation 'src';",
                            src: _ctx.mapUrl,
                            loading: "lazy",
                            width: "600",
                            height: "450",
                            style: {"border":"0"}
                          }, null, 8, _hoisted_7)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              : (_ctx.isRedirect)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_DetailList, {
                      variant: "rows",
                      items: _ctx.detailItems,
                      "data-testid": "v1-reference-details"
                    }, null, 8, ["items"]),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("button", {
                        class: "primary",
                        "data-testid": "v1-reference-primary",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onPrimary && _ctx.onPrimary(...args)))
                      }, _toDisplayString(_ctx.t("continue")), 1)
                    ])
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createVNode(_component_DetailList, {
                      variant: "rows",
                      items: _ctx.detailItems,
                      "data-testid": "v1-reference-details"
                    }, null, 8, ["items"]),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_AlertBanner, {
                        content: _ctx.t('payment-method-unsupported'),
                        "icon-alt": "Warning"
                      }, null, 8, ["content"])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("button", {
                        class: "primary",
                        "data-testid": "v1-reference-primary",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onPrimary && _ctx.onPrimary(...args)))
                      }, _toDisplayString(_ctx.t("return-to-home")), 1)
                    ])
                  ], 64))
          ]))
        : (_openBlock(), _createBlock(_component_NoPayments, { key: 3 }))
}